import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import renderEnvComponent from 'data/common/renderEnvComponent';
import BinaryPowerSwitch from './BinaryPowerSwitch';
import MotorControlDeviceC from './MotorControlDeviceC';
import SmokeDetector from './SmokeDetector';
import BasicForm from './BasicForm';

class ZwaveProductDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            binary_power_switch: () => <BinaryPowerSwitch {...this.props} />,
            motor_control_device_c: () => <MotorControlDeviceC {...this.props} />,
            smoke_detector: () => <SmokeDetector {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default withRouter(renderEnvComponent('scenes/Products/components/Product/Zwave/index', ZwaveProductDetail));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Zwave/index.js